import React, { useEffect, useRef, useState } from 'react';
import { IoIosArrowRoundDown } from "react-icons/io";
import { IoIosArrowRoundUp } from "react-icons/io";
import GlobalLikeDislikeResponse from './Global_like_dislike_response';
import renderMathInElement from 'katex/contrib/auto-render';
import SmilesRenderer from '../smileRenderer';
import ReactDOM from "react-dom/client";
import "./pdf-circle-and-web-view-common.css";
const Pdf_circle_mini_screen = () => {
  const contentRef = useRef(null);
  const containerRef = useRef(null);
  const showAskMore = new URLSearchParams(window.location.search).get('toShowAskMoreButton') === 'true';
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const [showScrollToBottom, setShowScrollToBottom] = useState(true);
  const [isScrollable, setIsScrollable] = useState(false);
  const [response, setResponse] = useState("");
  const [title, setTitle] = useState("");
  const [responseId, setResponseId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userQuery, setUserQuery] = useState("");
  const [subject, setSubject] = useState("");
  const [extractedText, setExtractedText] = useState("");
  const [screenshotUrl, setScreenshotUrl] = useState("");
  const [pdfTitle, setPdfTitle] = useState("");
  const [pageNumber, setPageNumber] = useState(null);
  const [pageContext, setPageContext] = useState("");

  window.showNotesDoubtResponse = (res) => {
    setResponse(res.response);
    setTitle(res.title);
    setResponseId(res.request_id || res.requestId);
    setUserId(res.userId);
    setUserQuery(res.userQuery || res.user_query || "");
    setSubject(res.subject || "");
    setExtractedText(res.extractedText || res.ocr_text || "");
    setScreenshotUrl(res.screenshotUrl || res.screenshot_url || "");
    setPdfTitle(res.pdfTitle || "");
    setPageNumber(res.pageNumber ?? null);
    setPageContext(res.pageContext || "");
  }

  // Scroll handler for showing/hiding scroll buttons
const handleScroll = () => {
  if (!contentRef.current) return;
  const { scrollTop, scrollHeight, clientHeight } = contentRef.current;

  const atBottom = scrollTop + clientHeight >= scrollHeight - 5;

  setShowScrollToTop(atBottom);
  setShowScrollToBottom(!atBottom);
};



  // Smooth scroll to top
  const scrollToTop = () => {
    if (!contentRef.current) return;
    contentRef.current.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Smooth scroll to bottom
  const scrollToBottom = () => {
    if (!contentRef.current) return;
    contentRef.current.scrollTo({
      top: contentRef.current.scrollHeight,
      behavior: 'smooth'
    });
  };

  const handleOpenDoubtChat = () => {
    console.log("ask doubt button clicked from pdf circle");
    if (window.AndroidInterface?.openActivity) {
      // const ctx = {
      //   userQuery,
      //   subject,
      //   response,
      //   showResponseBubble: true,
      //   origin: "PDF_CIRCLE",
      //   title,
      //   extractedText,
      //   screenshotUrl,
      //   requestId: responseId,
      //   pdfTitle,
      //   pageNumber,
      //   pageContext,
      //   userId,
      // };
      window.AndroidInterface.openActivity("DoubtChatActivity");
    }
  };
useEffect(() => {
  const contentElement = contentRef.current;
  if (contentElement) {
    // Pehle check karo scrollable hai ya nahi
    const checkScrollable = () => {
      setIsScrollable(contentElement.scrollHeight > contentElement.clientHeight);
    };

    checkScrollable(); // Initial check
    window.addEventListener("resize", checkScrollable); // Resize pe bhi check karna zaruri hai

    contentElement.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial scroll check

    return () => {
      contentElement.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", checkScrollable);
    };
  }
}, []);



  useEffect(() => {
    if (containerRef.current) {
      renderMathInElement(containerRef.current, {
        delimiters: [
          { left: "\\[", right: "\\]", display: true },
          { left: "\\(", right: "\\)", display: false },
          { left: "$$", right: "$$", display: true },
          { left: "$", right: "$", display: false }
        ]
      });

      const el = containerRef.current;
      if (!el) return;

      setTimeout(() => {
        const nodes = Array.from(el.querySelectorAll("smiles"));
        nodes.forEach((node, i) => {
          const smiles = (node.textContent || node.getAttribute("value") || "").trim();
          const mount = document.createElement("span");
          node.replaceWith(mount);
          console.log(smiles);
          ReactDOM.createRoot(mount).render(<SmilesRenderer key={Math.random()} smiles={smiles} />);
        });

      }, 200)

    }
  }, [response]);

  useEffect(() => {
  const contentElement = contentRef.current;
  if (contentElement) {
    // Pehle check karo scrollable hai ya nahi
    const checkScrollable = () => {
      setIsScrollable(contentElement.scrollHeight > contentElement.clientHeight);
    };

    checkScrollable(); // Initial check
    window.addEventListener("resize", checkScrollable); // Resize pe bhi check karna zaruri hai

    contentElement.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial scroll check

    return () => {
      contentElement.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", checkScrollable);
    };
  }
}, []);

  // Add scroll event listener
  useEffect(() => {
    const contentElement = contentRef.current;
    if (contentElement) {
      contentElement.addEventListener('scroll', handleScroll);
      // Initial check
      handleScroll();

      return () => {
        contentElement.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  return (
    <div className="absolute w-screen h-screen bg-zinc-900/60  flex justify-center items-center z-50">
      <div className="w-[100vw] h-[100vh]  bg-white overflow-hidden flex flex-col relative">
        {/* Header */}
        <div className="flex items-center px-4 py-1 h-[50px] flex-shrink-0">
          <div className="w-8 h-8  rounded-full flex items-center justify-center shadow-md">
            <img src={require("../../assets/icons/icon_chat_avatar.png")} alt="" />
          </div>
          <div className="ml-4">
            <p className="text-md text-[#37D3E7] font-bold">Instant Guru</p>
          </div>
        </div>

        {/* Content */}
        <div
          className="flex-1 px-6 py-4 text-sm text-gray-700 leading-relaxed overflow-y-auto relative"
          // style={{
          //   fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
          //   lineHeight: '1.7'
          // }}
          ref={contentRef}
        >
          {/* Response content */}
          <h2 className='text-lg font-bold text-primary'>{title}</h2>
          <hr className='mb-2' />
          <div className='whitespace-normal text-[15px]' dangerouslySetInnerHTML={{ __html: response.replaceAll("(bold)<b>", "</b>").replaceAll(/(\n){2,}/g, '</br>') }} ref={containerRef} />

          {/* Hamesha neeche render hoga */}
          <GlobalLikeDislikeResponse isPDFCircle={true} responseId={responseId} userId={userId} />
          <div className='h-32' />
        </div>

        {/* Ask More - visible only when query param toShowAskMoreButton=true */}
        {showAskMore && <div
          className="absolute bottom-[20vh] right-[5vh] z-20"
        >
          <div className="relative flex items-center justify-center w-[62px] h-[62px]">
            <span className="absolute inline-flex w-[62px] h-[62px] rounded-full bg-[#26C6DA] opacity-40 pulse-ring pointer-events-none" />
            <span className="absolute inline-flex w-[62px] h-[62px] rounded-full bg-[#26C6DA] opacity-20 pulse-ring-delayed pointer-events-none" />
            <button
              onClick={handleOpenDoubtChat}
              className="relative w-[62px] h-[62px] bg-[#26C6DA] rounded-full flex flex-col items-center justify-center shadow-lg active:scale-95 transition-transform z-10"
            >
              <span className='text-white font-bold text-[15px] leading-[14px] text-center'>Ask<br />More?</span>
            </button>
          </div>
        </div>}

        {/* Scroll to Top Button */}
        {isScrollable && showScrollToTop && (
          <div className="absolute bottom-20 left-[50%] -translate-x-[50%] group">
            <button
              onClick={scrollToTop}
              className="bg-[#000000CC]/80 hover:bg-zinc-600 text-white rounded-full p-1 py-1.5 px-3 shadow-lg transition-all duration-300 transform hover:scale-110"
            >
              <p className='text-sm flex items-center'>Upar jayein <p className='text-xl'><IoIosArrowRoundUp /></p>
              </p>
            </button>
          </div>
        )}

        {/* Scroll to Bottom Button */}
        {isScrollable && showScrollToBottom && (
          <div className="absolute bottom-20 left-[50%] -translate-x-[50%] group">
            <button
              onClick={scrollToBottom}
              className="bg-[#000000CC]/80 text-white rounded-full p-1 py-1.5 px-3 shadow-lg transition-all duration-300 transform hover:scale-110"
            >
              <p className="text-sm flex items-center">Neeche jayein <p className='text-xl'><IoIosArrowRoundDown /></p> </p>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Pdf_circle_mini_screen;